import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "region-selector" }

import { ref, watch, computed } from 'vue'
import { useCascaderAreaData } from '@/utils/area'

interface AreaValue {
    province?: string
    city?: string
    district?: string
}

interface Props {
    showProvince?: boolean
    showCity?: boolean
    showDistrict?: boolean
    modelValue: AreaValue
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RegionPicker',
  props: {
    showProvince: { type: Boolean, default: true },
    showCity: { type: Boolean, default: true },
    showDistrict: { type: Boolean, default: true },
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const regionData = useCascaderAreaData()

// 类型定义
const props = __props

const emit = __emit

// 数据相关
const rawData = regionData
const provinces = ref<{ code: string; name: string }[]>([])
const cities = ref<{ code: string; name: string }[]>([])
const districts = ref<{ code: string; name: string }[]>([])

// 选中值
const selectedProvince = ref('')
const selectedCity = ref('')
const selectedDistrict = ref('')

// 计算区是否可选的逻辑
const canSelectDistrict = computed(() => {
    if (props.showCity) return !!selectedCity.value
    return !!selectedProvince.value
})

// 初始化省份
provinces.value = rawData.map(p => ({ code: p.code, name: p.name }))

// 处理省份变化
const handleProvinceChange = (code: string) => {
    selectedCity.value = ''
    selectedDistrict.value = ''
    cities.value = []
    districts.value = []

    if (!code) return

    const province = rawData.find(p => p.code === code)
    if (!province) return
    // 如果显示市：正常加载市列表
    if (props.showCity) {
        cities.value = province.children?.map(c => ({ code: c.code, name: c.name })) || []
    } else if (props.showDistrict) { // 如果不显示市但显示区：直接加载所有区
        const allDistricts = province.children?.flatMap(c => c.children || []) || []
        districts.value = allDistricts.map(d => ({ code: d.code, name: d.name }))
    }
}

// 处理市变化
const handleCityChange = (code: string) => {
    selectedDistrict.value = ''
    districts.value = []

    if (!code || !selectedProvince.value) return

    const province = rawData.find(p => p.code === selectedProvince.value)
    const city = province?.children?.find(c => c.code === code)
    districts.value = city?.children?.map(d => ({ code: d.code, name: d.name })) || []
}

// 监听所有变化并更新值
watch([selectedProvince, selectedCity, selectedDistrict], ([province, city, district]) => {
        const value: AreaValue = {
        province: province || undefined,
        city: city || undefined,
        district: district || undefined
        }
        emit('update:modelValue', value)
    }
)

// 外部传入值的同步
watch(() => props.modelValue, (newVal) => {
    selectedProvince.value = newVal.province || ''
    selectedCity.value = newVal.city || ''
    selectedDistrict.value = newVal.district || ''

    // 根据传入的省初始化市数据
    if (newVal.province) {
        const province = rawData.find(p => p.code === newVal.province)
        cities.value = province?.children?.map(c => ({
            code: c.code,
            name: c.name
        })) || []
    }

    // 根据传入的市初始化区数据
    if (newVal.city) {
        const province = rawData.find(p => p.code === newVal.province)
        const city = province?.children?.find(c => c.code === newVal.city)
        districts.value = city?.children?.map(d => ({
            code: d.code,
            name: d.name
        })) || []
    }
},
{ immediate: true }
)

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showProvince)
      ? (_openBlock(), _createBlock(_component_el_select, {
          key: 0,
          modelValue: selectedProvince.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedProvince).value = $event)),
          placeholder: "请选择省",
          filterable: "",
          clearable: "",
          onChange: handleProvinceChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provinces.value, (province) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: province.code,
                label: province.name,
                value: province.code
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.showCity)
      ? (_openBlock(), _createBlock(_component_el_select, {
          key: 1,
          modelValue: selectedCity.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedCity).value = $event)),
          placeholder: "请选择市",
          filterable: "",
          clearable: "",
          disabled: !selectedProvince.value,
          onChange: handleCityChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cities.value, (city) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: city.code,
                label: city.name,
                value: city.code
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]))
      : _createCommentVNode("", true),
    (_ctx.showDistrict)
      ? (_openBlock(), _createBlock(_component_el_select, {
          key: 2,
          modelValue: selectedDistrict.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedDistrict).value = $event)),
          placeholder: "请选择区",
          filterable: "",
          clearable: "",
          disabled: !canSelectDistrict.value
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(districts.value, (district) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: district.code,
                label: district.name,
                value: district.code
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]))
      : _createCommentVNode("", true)
  ]))
}
}

})